/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-28 16:21:36
 * @LastEditTime: 2022-01-28 20:36:18
 * @LastEditors: zhao - 🍉
 * @Description: 
 * @FilePath: /zhzj-admin/src/page/HsbMarketPlatform/merchant/detail.jsx
 */
import { Button, Modal } from 'antd';
import React, { useState } from 'react'
import { dicRecvCertType, mapMerchantCardType } from '../../../axios/dictionaries';
import { CustomCol, CustomRow } from '../../../components/Custom';
import DetailTitle from '../../../components/DetailTitle';
import ModalScrollContainer from '../../../components/ModalScrollContainer';
import { fetchHSBMarketPlatformMerchantGet } from '../../../services/HSBMarketPlatform';
import { findDict } from '../../../utils';

const HsbMarketPlatformMerchantDetail = (props) => {
    const [visible, setVisible] = useState(false);
    const [detailData, setDetailData] = useState({});
    const open = (id) => {
        setVisible(true)
        postMerchantGet(id)
    }
    const close = () => {
        setVisible(false)
    }

    const postMerchantGet = (id) => {
        return fetchHSBMarketPlatformMerchantGet({id}).then(res => {
            setDetailData(res)
        })
    }
    props.getRef && props.getRef({ open });
    return (
        <Modal 
            title="商户信息" 
            width={650} 
            visible={visible} 
            onCancel={close} 
            footer={<Button onClick={close}>关闭</Button>}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }}>
                <div className="custom" >
                    <CustomRow divider>
                        <CustomCol label="市场商家名称" required={false} >
                            <span style={{ paddingLeft:6 }}>{detailData.mktMrchNm}</span>
                        </CustomCol>
                        <CustomCol label="市场商家编号" required={false} >
                            <span style={{ paddingLeft:6 }}>{detailData.mktMrchId}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="联系人名称" required={false} >
                            <span style={{ paddingLeft:6 }}>{detailData.ctcpsnNm}</span>
                        </CustomCol>
                        <CustomCol label="手机号码" required={false} >
                            <span style={{ paddingLeft:6 }}>{detailData.mblphNo}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                    
                        <CustomCol label="证件类型" required={false} >
                            <span style={{ paddingLeft:6 }}>{findDict( dicRecvCertType, detailData.crdtTp).title}</span>
                        </CustomCol>
                        <CustomCol label="证件号码" required={false} >
                            <span style={{ paddingLeft:6 }}>{detailData.crdtNo}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="市场编号" required={false} >
                            <span style={{ paddingLeft:6 }}>{detailData.mktId}</span>
                        </CustomCol>
                        <CustomCol label="POS编号" required={false} >
                            <span style={{ paddingLeft:6 }}>{detailData.posNo}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="自定义编号" required={false} >
                            <span style={{ paddingLeft:6 }}>{detailData.udfId}</span>
                        </CustomCol>
                        <CustomCol label="商家柜台代码" required={false} >
                            <span style={{ paddingLeft:6 }}>{detailData.mrchCnterCd}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="商家证件类型" required={false} >
                            <span style={{ paddingLeft:6 }}>{findDict(mapMerchantCardType, detailData.mrchCrdtTp).title}</span>
                        </CustomCol>
                        <CustomCol label="商家证件号码" required={false} >
                            <span style={{ paddingLeft:6 }}>{detailData.mrchCrdtNo}</span>
                        </CustomCol>
                    </CustomRow>
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}

export default HsbMarketPlatformMerchantDetail


// WEBPACK FOOTER //
// ./src/page/HsbMarketPlatform/merchant/detail.jsx